import { DefaultRequest } from 'scripts/api';

Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.UploadWindow = function () {

    this.entity = "SurveyReportUpload";

    this.el;
    this.selector = "#Survey";
    this.scopeBlock = this.selector;
    this.options = {
        width: 600,
        height: 440
    };
    this.monetMessage = new Monet.Form.Messages.InlineMessage();
    this.monetMessage.setScope("#Survey .popupFormContainer");
    this.monetMessage.setInfoType("error");

    this.blocked = function () {
        this.block.style.display = "block";
    };

    this.unblocked = function () {
        this.block.style.display = "none";
    };

    this.showError = function (messages) {
        this.unblocked();
        this.monetMessage.setMessage(messages);
        this.monetMessage.triggerMessage();
    };

    this.validateErrors = (xhr) => {
        const responseText = xhr.responseText;
        const isJson = (str) => {
            try {
                if(str)
                    JSON.parse(str);
                else
                    return false;
            } catch (e) {
                return false;
            }
            return true;
        }
        const messages = isJson(responseText) ? JSON.parse(responseText) : responseText;
        this.showError(messages);
    };

    this.processModel = () => {
        Greenmile.Survey.Modal.UploadModal.clear();

        const modalGenerateReport = document.querySelector("#Survey .popupFormContainer");
        modalGenerateReport && (modalGenerateReport.innerHTML = "");

        var modal = new Greenmile.Survey.ReportWindow();
        modal.surveyId = this.surveyId;
        modal.showModalForm();
    };

    this.submit = function (config) {

        var data, format;
        if (config.formData instanceof FormData) {
            data = config.formData;
            format = 'multipart/form-data';
        } else {
            data = config.formData;
            config.method = "PUT";
            format = 'application/json';
        }

        const request = new DefaultRequest({
            data,
            url: config.url,
            method: config.method,
            contentType: format,
            success: this.processModel,
            error: this.validateErrors
        });
        request.send();
    };

    this.createFormData = function (file) {

        var description = this.form.getField("description").getValue();
        var reportTemplate = {
            description: description,
            originalFileName: file.name
        };

        var entityName = "reportTemplate";
        var json = {};

        if (this.model) {
            reportTemplate["id"] = this.model.id;
            reportTemplate["surveys"] = [{ id: this.surveyId }];
            json = reportTemplate;
        } else {
            entityName = "entity";
            json["surveyId"] = this.surveyId;
            json["reportTemplate"] = reportTemplate;
        }

        var formData = new FormData();
        formData.append("file", new Blob([file]), file.name);
        formData.append(entityName, new Blob([JSON.stringify(json)], { type: "application/json" }), entityName);

        return formData;
    };

    this.createFormDataJson = function () {
        return {
            description: this.form.getField("description").getValue(),
            originalFileName: this.model.originalFileName,
            id: this.model.id,
            surveys: [
                {
                    id: this.surveyId
                }
            ]
        };
    };

    this.update = function () {

        var fieldFile = this.form.getField("file");
        fieldFile.types = ["xlsx"];
        fieldFile.maxFileLength = 1e+7;

        var validated = this.form.validate();

        if (validated.status) {

            var file = fieldFile.getFile();

            var config = {
                method: "POST",
                url: "/ReportTemplate/" + this.model.id
            };

            if (file) {
                config.formData = this.createFormData(file);
            } else {
                config.formData = this.createFormDataJson();
            }

            this.submit(config);
        } else {
            this.showError(validated);
        }

    };

    this.create = function () {
        var fieldFile = this.form.getField("file");
        fieldFile.types = ["xlsx"];
        fieldFile.maxFileLength = 1e+7;

        var validated = this.form.validate();

        if (validated.status) {

            var file = fieldFile.getFile();

            this.submit({
                method: "POST",
                url: '/ReportTemplate',
                formData: this.createFormData(file)
            });

        } else {
            this.showError(validated);
        }
    };

    this.save = function () {
        this.blocked();
        if (this.model) {
            this.update();
        } else {
            this.create();
        }
    };

    this.layout = {
        "id": 99999,
        "userInterfaceAction": {
            "userInterface": {
                "id": 99999,
                "key": "SurveyReport",
                "description": "surveyreportupload.userinterface.description"
            },
            "key": "upload"
        },
        "sections": [
            {
                "id": 99999,
                "pageLayout": {
                    "id": 99999
                },
                "key": "pls_upload_surveyreport",
                "description": " ",
                "layoutColumns": 1,
                "layoutOrder": 1,
                "sectionRelatedLists": [],
                "sectionFields": [],
                "sectionButtons": [
                    {
                        "pageLayoutSection": {
                            "id": 99999
                        },
                        "customLabel": "default.button.save",
                        "customJavaScript": this.save.bind(this),
                        "buttonOrder": 1,
                        "name": "btn_save"
                    },
                    {
                        "pageLayoutSection": {
                            "id": 99999
                        },
                        "customLabel": "general.button.cancel",
                        "customJavaScript": function () {
                            Greenmile.Survey.Modal.UploadModal.renderEl();
                        },
                        "buttonOrder": 2,
                        "name": "btn_cancel"
                    }
                ]
            },
            {
                "id": 99999,
                "pageLayout": {
                    "id": 99999
                },
                "key": "pls_upload_surveyreportupload",
                "description": "surveyreport.upload.description",
                "layoutColumns": 1,
                "layoutOrder": 3,
                "sectionRelatedLists": [],
                "sectionFields": [
                    {
                        "pageLayoutSection": {
                            "id": 99999
                        },
                        "sectionOrder": 1,
                        "formEvents": [],
                        "field": {
                            lookupEntity: null,
                            lookupEntityColumn: undefined,
                            description: "description",
                            id: 99997,
                            label: "surveyreportupload.description",
                            mandatory: true,
                            meta: null,
                            name: "description",
                            type: "TEXT",
                            maxSize: 255
                        },
                        "sectionColumn": 1
                    },
                    {
                        "pageLayoutSection": {
                            "id": 99999
                        },
                        "sectionOrder": 3,
                        "formEvents": [],
                        "field": {
                            "id": 99998,
                            "name": "file",
                            "label": "surveyreportupload.file",
                            "entity": {
                                "id": 99996
                            },
                            "description": "Select a file",
                            "type": "FILE",
                            "readOnly": true,
                            "mandatory": true
                        },
                        "sectionColumn": 1
                    }
                ],
                "sectionButtons": []
            }
        ]
    };

    this.populate = function () {
        if (this.model) {
            var fieldFile = this.form.getField("file");
            fieldFile.setValue(this.model.originalFileName);

            var description = this.form.getField("description");
            description.setValue(this.model.description);
        }
    };

    this.renderEl = function () {
        var container = document.querySelector(this.selector + " .popupFormContainer");
        container.innerHTML = '';
        this.form = new Monet.Builder.Form.Horizontal(this.layout, this.entity);
        this.el = this.form.render();

        this.block = document.createElement("div");
        this.block.setAttribute("class", "block");

        this.unblocked();

        container.appendChild(this.block);

        container.appendChild(this.el);

        const inputFile = document.querySelector('#Survey #SurveyReportUpload_file [name="file"]');
        inputFile && inputFile.setAttribute('placeholder', Monet.I18n.getResourcesByKey('Survey.uploadWindow.placeholderFieldFile'));

        this.populate();
    };


    this.callbacks = {
        onAfterShowModalForm: this.renderEl.bind(this)
    };


};

Greenmile.Survey.UploadWindow.prototype = new Monet.Form.Modal;
